import vFlexContainer from './FlexContainer';

export { vFlexContainer };



// WEBPACK FOOTER //
// ./src/modules/sign/baseComponents/FlexContainer/index.js